import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type rxicCredType = CarrierLogisticsCredType
export const rxicDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const rxic: CarrierDef<rxicCredType> = {
  name: 'Ross Express Inc',
  scac: 'rxic',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'tracking', 'profinder'],
  documentTypes: rxicDocumentTypes,
}
